import { isBrowser } from '@app/utils/isBrowser'

declare global {
  interface Window {
    fbq: any
  }
}

interface FBEvent {
  action?: string
  category?: string
  label?: string
  value?: string
}

const event = (event: FBEvent): void => {
  if (!isBrowser || !window.fbq) return

  window.fbq('trackCustom', event.action, {
    event_category: event.category,
    event_label: event.label,
    value: event.value
  })
}

export const bookingStarted = (): void => {
  event({
    action: 'Booking started',
    category: eventsCategories.booking,
    label: 'booking'
  })
}

export const bookingPersonalFormSubmitted = (): void => {
  event({
    action: 'Lead',
    category: eventsCategories.booking
  })
}

export const bookingCallMeNowClicked = (): void => {
  event({
    action: 'Contact',
    category: eventsCategories.booking
  })
}

const eventsCategories = {
  booking: 'parent_booking_flow'
}
